/* eslint-disable */
import red from '@material-ui/core/colors/red';
import boralLogoUrl from '../../Assets/Logos/Boral-84x69.png';
import {
  THEME_BREAKPOINT_LG_STEP,
  THEME_BREAKPOINT_LG_UNIT,
  THEME_BREAKPOINT_MD_STEP,
  THEME_BREAKPOINT_MD_UNIT,
  THEME_BREAKPOINT_SM_STEP,
  THEME_BREAKPOINT_SM_UNIT,
  THEME_BREAKPOINT_XL_STEP,
  THEME_BREAKPOINT_XL_UNIT,
  THEME_BREAKPOINT_XS_STEP,
  THEME_BREAKPOINT_XS_UNIT,
  THEME_PALETTE_TYPE_LIGHT,
} from '../../Constants/Theme/Theme.constants';
import { createLoginPageLink } from '../../Pages/Login/Login.page.route';
import { createOrdersPageLink } from '../../Pages/Orders/Orders.page.route';
import { ENTRY_PORTAL_CUSTOMER_COMPANY, ENTRY_PORTAL_CUSTOMER_NAME } from './PortalCustomer.entry.constants';
import Colors from 'Support/Theme/Colors/Colors';

/**
 * @type {Entry}
 */
const portalCustomerEntry = {
  breakpoints: [
    {
      step: THEME_BREAKPOINT_XS_STEP,
      unit: THEME_BREAKPOINT_XS_UNIT,
    },
    {
      step: THEME_BREAKPOINT_SM_STEP,
      unit: THEME_BREAKPOINT_SM_UNIT,
    },
    {
      step: THEME_BREAKPOINT_MD_STEP,
      unit: THEME_BREAKPOINT_MD_UNIT,
    },
    {
      step: THEME_BREAKPOINT_LG_STEP,
      unit: THEME_BREAKPOINT_LG_UNIT,
    },
    {
      step: THEME_BREAKPOINT_XL_STEP,
      unit: THEME_BREAKPOINT_XL_UNIT,
    },
  ],
  company: ENTRY_PORTAL_CUSTOMER_COMPANY,
  logoLargeUrl: boralLogoUrl,
  name: ENTRY_PORTAL_CUSTOMER_NAME,
  palette: {
    background: {
      default: `#fff`,
      paper: `#fff`,
    },
    error: red,
    primary: {
      main: `#00A94F`,
    },
    secondary: {
      main: `#FFDE00`,
    },
    type: THEME_PALETTE_TYPE_LIGHT,
  },
  postLoginLink: createOrdersPageLink(),
  postLogoutLink: createLoginPageLink(),
  shape: {
    borderRadius: 0,
  },
  spacing: {
    unit: 8,
  },
  version: 6,
  boralcolorspalette: Colors,
};

export default portalCustomerEntry;
